import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Button, Tooltip } from "antd";
import dayjs from "dayjs"; // Ant Design supports dayjs by default

const DownloadTable = ({
  history,
  loading,
  data,
  callReFetch,
  dispatch,
  handleDelete,
}) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // Update isMobileView on resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = [
    {
      title: "DATE",
      dataIndex: "currentDatetime",
      key: "currentDatetime",
      render: (value) => (value ? dayjs(value).format("YYYY-MM-DD") : "-"),
    },
    {
      title: "Department",
      dataIndex: "dept",
      key: "dept",
    },
    {
      title: "Download Link",
      dataIndex: "link",
      key: "link",
      render: (link) =>
        link ? (
          <Tooltip title="Download file">
            <Button
              type="primary"
              onClick={() => window.open(link, "_blank")}
              size="small"
            >
              Download
            </Button>
          </Tooltip>
        ) : (
          "-"
        ),
    },
  ];

  return (
    <div style={{ width: "50vw" }}>
      <Spin spinning={loading}>
        {data && (
          <Table
            columns={columns}
            dataSource={data}
            rowKey={(record) => record._id || record.link} // ensures unique keys
            pagination={{ pageSize: 10 }}
          />
        )}
      </Spin>
    </div>
  );
};

DownloadTable.propTypes = {
  history: PropTypes.object,
  loading: PropTypes.bool,
  data: PropTypes.array,
  callReFetch: PropTypes.func,
  dispatch: PropTypes.func,
  handleDelete: PropTypes.func,
};

export default DownloadTable;
